import React, { useState, useEffect } from 'react';
import apiClient from '../../../utils/api';
import { Button } from '../../ui/button';
import { toast } from 'sonner';
import { Palette, Loader2, Check } from 'lucide-react';

export const DesignPicker = ({ compositionId, propertyData, currentDesignId, onDesignApplied }) => {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [applying, setApplying] = useState(null);

  useEffect(() => {
    apiClient.get('/reels/designs').then(res => {
      setDesigns(res.data.designs || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const applyDesign = async (designId) => {
    setApplying(designId);
    try {
      const res = await apiClient.post(`/reels/designs/${designId}/apply`, {
        property_data: propertyData || {},
        composition_id: compositionId,
      });
      toast.success('Design applied!');
      onDesignApplied(res.data.layers || res.data?.layers, designId);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to apply design');
    }
    setApplying(null);
  };

  if (loading) return null;

  return (
    <div className="border border-border/50 rounded-lg bg-card p-3" data-testid="design-picker">
      <h3 className="text-sm font-semibold flex items-center gap-1.5 mb-2">
        <Palette className="h-4 w-4" /> Design Templates
      </h3>
      <div className="space-y-1.5">
        {designs.map(d => (
          <div
            key={d.design_id}
            className={`flex items-center gap-2 p-2 rounded cursor-pointer transition-colors border ${
              currentDesignId === d.design_id ? 'border-purple-500/50 bg-purple-500/10' : 'border-transparent hover:bg-muted/20'
            }`}
            data-testid={`design-${d.design_id}`}
          >
            <div className="w-8 h-8 rounded flex-shrink-0" style={{ backgroundColor: d.preview_color }} />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium">{d.name}</p>
              <p className="text-[10px] text-muted-foreground truncate">{d.layer_count} layers</p>
            </div>
            <Button
              variant={currentDesignId === d.design_id ? "secondary" : "outline"}
              size="sm"
              className="h-6 text-xs"
              onClick={() => applyDesign(d.design_id)}
              disabled={applying === d.design_id}
              data-testid={`apply-design-${d.design_id}`}
            >
              {applying === d.design_id ? <Loader2 className="h-3 w-3 animate-spin" /> :
               currentDesignId === d.design_id ? <Check className="h-3 w-3" /> : 'Use'}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
